import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import "./WhyUs.css";

const points = [
  {
    icon: "fa-chart-line",
    title: "97% Uptime target",
    text: "We aim for high availability so your workloads stay running.",
  },
  {
    icon: "fa-headset",
    title: "24/7 Dedicated support",
    text: "Get help when you need it. We aim to respond within 24 hours.",
  },
  {
    icon: "fa-shield-halved",
    title: "Secure infrastructure",
    text: "We take security seriously and handle data in line with applicable practices.",
  },
];

const WhyUs = () => (
  <section className="hn-whyus">
    <Container>
      <h2 className="hn-whyus-title">Why Hosting Noodle</h2>
      <p className="hn-whyus-subtitle text-muted">Reliable hosting with support you can count on.</p>
      <Row className="g-4">
        {points.map((point, i) => (
          <Col key={i} xs="12" sm="6" md="4">
            <div className="hn-whyus-card">
              <div className="hn-whyus-icon-wrap">
                <i className={`fas ${point.icon}`} aria-hidden="true" />
              </div>
              <h3 className="hn-whyus-card-title">{point.title}</h3>
              <p className="hn-whyus-card-text">{point.text}</p>
            </div>
          </Col>
        ))}
      </Row>
      <p className="hn-whyus-contact text-center mt-3 mb-0">
        Questions? <Link to="/contact">Contact us</Link> — we’re here to help.
      </p>
    </Container>
  </section>
);

export default WhyUs;
